<template>
  <span
    class="inline-block max-w-full animate-pulse select-none"
    aria-hidden="true"
  >&nbsp;</span>
</template>
